/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Required_WardInputs */

const vi_validation_required_ward = /** @type {(inputs: Validation_Required_WardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng chọn xã / phường`)
};

/**

* @param {Validation_Required_WardInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const validation_required_ward = /** @type {((inputs?: Validation_Required_WardInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Required_WardInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_validation_required_ward(inputs)
});